module.exports = __webpack_public_path__ + "images/emoji/cow2.2c336ac0e40717c8c32f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/cow2.png
// module id = gRnk
// module chunks = 1